import * as constAction from 'root/actionConstants';

export const clear = (value) => ({
  type: constAction.PRECIO_CLEAR,
  payload: value,
});

export const setState = (values) => ({
  type: constAction.PRECIO_SET_STATE,
  payload: values,
});

export const get = () => ({
  type: constAction.PRECIO_GET,
  epic: {
    url: 'precioBoletos/getList',
    method: 'GET',
  },
});

export const getActivos = () => ({
  type: constAction.PRECIO_GET_ACTIVOS,
  epic: {
    url: 'precioBoletos/getActivos',
    method: 'GET',
  },
});

export const set = (payload) => ({
  type: constAction.PRECIO_SET,
  payload,
  epic: {
    url: 'precioBoletos/crear',
    method: 'POST',
  },
});

export const deleteItem = (id) => ({
  type: constAction.PRECIO_DELETE,
  payload: { id },
  epic: {
    url: 'precioBoletos/eliminar/',
    method: 'post',
  },
});

export const updateViajes = (precioBoletoId, confirmacion) => ({
  type: constAction.PRECIO_UPDATE_VIAJES,
  payload: {
    precioBoletoId,
    confirmacion,
  },
  epic: {
    url: 'precioBoletos/updateViajes',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/precios/action.js